// extracted by mini-css-extract-plugin
module.exports = {"skipLink":"styles_skipLink__S1BCU"};